import React from "react";
import { Modal } from "@mantine/core";
import { IconChevronDown, IconChevronUp, IconCopy } from "@tabler/icons-react";
import ButtonWithPopoverFeedback from "../ButtonWithPopoverFeedback";

export const CELL_BORDER = "1px solid #e0e0e0";

export function SortIcon({ sorted }) {
	if (sorted === "asc")
		return <IconChevronUp size={11} style={{ flexShrink: 0 }} />;
	if (sorted === "desc")
		return <IconChevronDown size={11} style={{ flexShrink: 0 }} />;
	return (
		<span style={{ opacity: 0.25, flexShrink: 0 }}>
			<IconChevronUp size={11} />
		</span>
	);
}

const MODAL_TD_LABEL = {
	padding: "4px 8px",
	fontFamily: "monospace",
	fontSize: 12,
	fontWeight: 600,
	color: "#555",
	whiteSpace: "nowrap",
	border: "1px solid #eee",
	backgroundColor: "#f5f5f5",
	width: "1px",
};

const MODAL_TD_VALUE = {
	padding: "4px 8px",
	fontFamily: "monospace",
	fontSize: 12,
	border: "1px solid #eee",
	wordBreak: "break-all",
};

const MODAL_TD_BTN = {
	padding: "2px 4px",
	border: "1px solid #eee",
};

export function FullValueModal({ fullValue, onClose, defaultTitle = "Value" }) {
	return (
		<Modal
			opened={fullValue !== null}
			onClose={onClose}
			title={
				fullValue?.label ? (
					<span style={{ fontFamily: "monospace", fontSize: 13 }}>
						{fullValue.label}
					</span>
				) : (
					defaultTitle
				)
			}
			size="lg"
			transitionProps={{ duration: 0 }}
		>
			{fullValue?.friendlyValue != null ? (
				<table style={{ borderCollapse: "collapse", width: "100%" }}>
					<tbody>
						<tr>
							<td style={MODAL_TD_LABEL}>
								{fullValue.friendlyLabel}
							</td>
							<td style={MODAL_TD_VALUE}>
								{fullValue.friendlyValue}
							</td>
							<td style={MODAL_TD_BTN}>
								<ButtonWithPopoverFeedback
									iconComponent={<IconCopy size={13} />}
									onClick={() =>
										navigator.clipboard.writeText(
											fullValue.friendlyValue
										)
									}
									feedbackMessage="Copied!"
									title="Copy"
								/>
							</td>
						</tr>
						<tr>
							<td style={MODAL_TD_LABEL}>original</td>
							<td style={MODAL_TD_VALUE}>{fullValue.value}</td>
							<td style={MODAL_TD_BTN}>
								<ButtonWithPopoverFeedback
									iconComponent={<IconCopy size={13} />}
									onClick={() =>
										navigator.clipboard.writeText(
											fullValue.value
										)
									}
									feedbackMessage="Copied!"
									title="Copy"
								/>
							</td>
						</tr>
					</tbody>
				</table>
			) : (
				<>
					<div
						style={{
							display: "flex",
							justifyContent: "flex-end",
							marginBottom: 6,
						}}
					>
						<ButtonWithPopoverFeedback
							iconComponent={<IconCopy size={13} />}
							onClick={() =>
								navigator.clipboard.writeText(
									fullValue?.value ?? ""
								)
							}
							feedbackMessage="Copied!"
							title="Copy"
						/>
					</div>
					<pre
						style={{
							fontFamily: "monospace",
							fontSize: 12,
							whiteSpace: "pre-wrap",
							wordBreak: "break-all",
							margin: 0,
						}}
					>
						{fullValue?.value}
					</pre>
				</>
			)}
		</Modal>
	);
}
